import { css } from '@emotion/core';
var _ref = {
  name: "1f2po4u",
  styles: "> *:first-child{margin-top:0;}"
};
export function resetTopMargin() {
  return _ref;
}
var _ref2 = {
  name: "ixvsjt",
  styles: "> *:last-child{margin-bottom:0;}"
};
export function resetBottomMargin() {
  return _ref2;
}